 <div class="unauthorized-container">
    <div class="unauthorized-message">
    <h1>Unauthorized Access</h1>
    <p>You are not authorized to access this application.</p>
    <p>Please contact your administrator if you believe this is an error.</p>
    </div>
</div>